import React from 'react'

export default function manageLeaveRequest() {
  return (
    <div>manageLeaveRequest</div>
  )
}
